import { ModelRepository } from 'b302-frontend-library';
import WhitelistUser from '../models/WhitelistUser';

class WhitelistRepository extends ModelRepository<WhitelistUser> {

    public constructor() {
        super('/user-whitelists');
    }
}

export default WhitelistRepository;
